// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --background-color: #fff;
  --text-color: #000;
  --primary-color: #fff;
  --secondary-color: #fff;
  --highlight-color: #f4f4f6;
  --modal-background: #fefefe;
}

[data-theme="dark"] {
  --background-color: #000000;
  --text-color: #f0f0f0;
  --primary-color: #111b21;
  --secondary-color: #000000;
  --highlight-color: #222e35;
  --modal-background: #111b21;
}
#select1 {
  color: var(--text-color);
  background-color: var(--background-color);
}
.select11 {
  background-color: var(--secondary-color);
  color: var(--text-color);
}
.text1 {
  color: var(--text-color);
}
.header-text {
  color: var(--text-color);
}
#modalBack {
  background-color: var(--highlight-color);
}
body {
  background-color: var(--background-color);
  color: var(--text-color);
}
.theme-switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 15px;
}

.theme-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}
.transaction-summary {
  background-color: var(--highlight-color);
}
.optionss {
  background-color: var(--background-color);
  color: var(--text-color);
}
.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 0px;
  bottom: 1px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #4caf50;
}

input:checked + .slider:before {
  transform: translateX(17px);
}

header {
  background-color: var(--background-color);
  color: var(--text-color);
  padding: 20px;
  border-radius: 10px;
  margin-top: 5px;
  margin-left: 10px;
  margin-right: 10px;
}

.wallet-header {
  background: var(--highlight-color);
  color: var(--text-color);
}

.wallet-tabs .active {
  background: var(--primary-color);
  color: var(--text-color);
}
h1 {
  color: white;
}
.button-group {
  margin-top: 30px;
  display: flex;
  gap: 10px; /* Optional spacing between buttons */
}

.tab-button {
  background-color: var(--highlight-color); /* Default background color */
  color: var(--text-color);
  border: 1px solid white;
  border-radius: 5px;
  padding: 10px 20px; /* Adjust padding for size */
  cursor: pointer;
  font-size: 14px; /* Adjust font size */
}

.tab-button.active {
  background-color: #7d9aea; /* Background color for active state */
}

.button-group .tab-button {
  background-color: var(--highlight-color);
  color: var(--text-color);
  padding: 5px;
  width: 150px;
}
.yaxis-graph {
  color: var(--text-color);
}
/* .footer-icons li {
  padding: 3px;
  cursor: pointer;
  border-radius: 5px;
  margin: 0 3px;
} */

.footer-icons li.active {
  color: #7d9aea; /* Active text color */
}
.modal-content5 {
  background-color: var(--highlight-color);
}
.button-group .tab-button.active {
  background-color: #7d9aea;
  color: black;
  padding: 5px;
}
.period-button {
  padding: 5px 10px;
  color: var(--text-color);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  background-color: var(--highlight-color); /* Default background color */
}
.cntact-usss {
  color: var(--text-color);
  border-bottom: 1px solid var(--text-color);
  width: 30%;
}
.contect-us-header {
  text-align: center; /* Center text */
  border-bottom: 1px solid var(--text-color); /* Border under text */
  display: inline-block; /* Makes the width fit the content */
  margin: 0 auto; /* Centers the block horizontally */
  padding-bottom: 5px; /* Adds space between the text and border */
}

.period-button.selected {
  background-color: #7d9aea; /* Background color when selected */
  color: white;
}

.banner {
  background: linear-gradient(
    to right,
    var(--primary-color),
    var(--secondary-color)
  );
  color: var(--text-color);
}

.market-item {
  background-color: var(--background-color);
  color: var(--text-color);
}

.market-item:hover {
  background-color: var(--highlight-color);
}

.copied-message {
  position: fixed;
  top: 10px;
  right: 10px;
  background-color: var(--highlight-color);
  color: var(--text-color);
  padding: 10px;
  border-radius: 5px;
  z-index: 1000;
}

.wallet {
  width: 100%;
  max-width: 500px;
  background: var(--highlight-color);
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  text-align: center;
  margin: 17px auto;
}

.wallet-header {
  background: var(--highlight-color);
  padding: 10px;
  color: var(--text-color);
}
/* #recharge-modal {
  background-color: var(--background-color);
} */
.wallet-header h1 {
  margin: 0;
  font-size: 24px;
}

.wallet-balance {
  padding: 10px;
  color: var(--text-color);
}

.wallet-balance p {
  margin: 5px 0;
  font-size: 16px;
}
#recharggge {
  background-color: var(--highlight-color);
}
b,
strong {
  font-weight: bolder;
  color: white;
}
.wallet-tabs {
  padding: 5px;
  display: flex;
  justify-content: space-around;
  background: var(--highlight-color);
}
.tabsss {
  border: "1px solid white";
}

.wallet-tabs button {
  flex: 1 1;
  padding: 5px;
  border: none;
  background: transparent;
  font-size: 16px;
  cursor: pointer;
  outline: none;
}

.wallet-tabs .active {
  background: #7d9aea;
  color: white;
  border-radius: 5px;
}

.wallet-content {
  padding: 20px;
}

.tab-content {
  display: none;
}

.tab-content.active {
  display: block;
}

.wallet-qr img {
  width: 150px;
}

.wallet-qr p {
  font-size: 12px;
  color: var(--text-color);
}

.copy-address {
  color: var(--secondary-color);
  text-decoration: blink;
  cursor: pointer;
}

.recharge-link {
  color: var(--secondary-color);
  text-decoration: blink;
  cursor: pointer;
}

.currency-tag {
  background: #ff9800;
  color: white;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 14px;
  display: inline-block;
  margin-right: 10px;
}

.input-field {
  width: calc(100% - 40px);
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: var(--background-color);
  color: var(--text-color);
}

.input-field.small-input {
  width: calc(50% - 40px);
}

.send-button,
.convert-button {
  /* background: linear-gradient(to right, var(--secondary-color), #feb47b); */
  color: var(--text-color);
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  width: calc(100% - 40px);
  margin: 10px 20px;
}

.max-button {
  color: var(--secondary-color);
  cursor: pointer;
  margin-left: 10px;
}

.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1000; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto; /* Enable scroll if needed */
  background-color: var(--background-color); /* Black w/ opacity */
}

.modal.show {
  display: flex; /* Display the modal */
  justify-content: center; /* Center the modal content */
  align-items: center; /* Center the modal content */
}
.modal-content1 {
  background-color: var(--background-color);
}

.modal-content {
  background-color: var(--background-color);
  padding: 20px;
  border: 1px solid #888;
  width: 90%;
  max-width: 500px;
  border-radius: 10px;
  /* height: 400px; */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 60px;
}

.close {
  color: var(--text-color);
  font-size: 28px;
  font-weight: bold;
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
}
.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
}
/* .form-group {
  margin: 5px 0;
} */

.form-group label {
  display: block;
  /* margin-bottom: 5px; */
  font-weight: bold;
  color: var(--text-color);
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: var(--background-color);
  color: var(--text-color);
}

.upload-screenshot {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding: 20px; */
  border: 2px dashed #ccc;
  border-radius: 10px;
  cursor: pointer;
  background-color: var(--background-color);
  color: var(--text-color);
}

.upload-icon {
  font-size: 36px;
  color: var(--secondary-color);
  margin-bottom: 10px;
}

.upload-screenshot img {
  max-width: 30%;
  height: auto;
  margin-top: 10px;
}

.submit-button {
  background: linear-gradient(to right, var(--secondary-color), #feb47b);
  color: white;
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  width: 100%;
  margin-top: 20px;
}
/* .featured-crypto-list {
  background-color: var(--highlight-color);
} */
#predict-chart {
  background-color: var(--background-color);
  color: var(--text-color);
}
.prediction-summary {
  background-color: var(--background-color);
}
.container {
  width: 100%;
  max-width: 100%;
  background: var(--background-color);
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow-y: auto;
  height: 100vh; /* Ensure the container takes the full height of the viewport */
}
.featured-crypto-item {
  background-color: var(--background-color);
}
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px; /* Add padding to make it look better */
  background: var(--background-color);
  color: var(--text-color);
  position: sticky; /* Make the header stick to the top */
  top: 0;
  z-index: 10;
  width: 95%; /* Make sure the header takes full width of the container */
  box-sizing: border-box; /* Include padding and border in the element's total width and height */
}
#entrustModal {
  background-color: var(--background-color);
}
header .title-container {
  display: flex;
  align-items: center;
  /* background: var(--highlight-color); */
}
.back-button {
  color: var(--text-color);
}
#crypto-modal {
  background-color: var(--background-color);
}
#copy-texts {
  color: var(--text-color);
}
.modal.show {
  display: flex; /* Display the modal */
  justify-content: center; /* Center the modal content horizontally */
  align-items: center; /* Center the modal content vertically */
}
#wallet-modalss {
  background-color: var(--background-color);
  /* background-color: var(--highlight-color); */
  /* background-color: var(--highlight-color); */
  margin: 5% auto; /* Adjusted for better alignment */
  padding: 20px;
  border: 1px solid #888;
  width: 90%; /* Could be more or less, depending on screen size */
  max-width: 500px;
  border-radius: 10px;
  margin-top: 50px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.modal-content {
  background-color: var(--background-color);
  margin: 5% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 90%;
  max-width: 500px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 50px;
}

.close {
  color: var(--text-color);
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

header h1 {
  margin: 0;
  font-size: 24px;
  display: flex;
  align-items: center;
}

.icons {
  display: flex;
  align-items: center;
}

.icon-notification {
  width: 24px;
  height: 24px;
  cursor: pointer;
  margin-left: 10px;
}

.menu-button {
  background: transparent;
  color: var(--text-color);
  border: none;
  font-size: 24px;
  cursor: pointer;
  margin-left: auto; /* Push the menu button to the far right */
}

.sidebar {
  position: fixed;
  left: -250px;
  top: 0;
  width: 210px;
  height: 100%;
  background-color: var(--highlight-color);
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  transition: left 0.3s;
  z-index: 1000;
  overflow-y: auto;
}

.sidebar.open {
  left: 0;
}

.sidebar-header {
  text-align: center;
  padding: 20px;
  background-color: var(--highlight-color);
  color: var(--text-color);
  border-bottom: 0.5px solid rgb(197, 194, 194);
}

.sidebar-header h2 {
  margin: 0;
  font-size: 24px;
}

.sidebar-header p {
  margin: 0;
  font-size: 14px;
  color: var(--text-color);
}

.credit {
  display: inline-block;
  background-color: #e0e0e0;
  color: #333;
  padding: 5px 10px;
  border-radius: 5px;
  margin-top: 10px;
}

.smart-contract-button {
  display: block;
  width: 80%;
  margin: 20px auto;
  background: linear-gradient(to right, var(--secondary-color), #feb47b);
  color: white;
  border: none;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.functions {
  margin-top: 30px;
  padding: 0 20px;
}

.functions h3 {
  margin: 0;
  font-size: 18px;
  color: var(--text-color);
}

.functions ul {
  list-style-type: none;
  padding: 0;
}

.functions li {
  padding: 10px 0;
  display: flex;
  align-items: center;
  font-size: 16px;
  cursor: pointer;
}

.functions li a {
  text-decoration: none;
  color: inherit;
}

.functions li:hover a {
  color: var(--secondary-color);
}

.functions li i {
  margin-right: 10px;
}

.more-options-button {
  display: block;
  width: 80%;
  margin: 20px auto;
  color: black;
  border: none;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.more-options.hidden {
  display: none;
}

.more-options ul {
  list-style-type: none;
  padding: 0;
}

.more-options li {
  padding: 10px 0;
  display: flex;
  align-items: center;
  font-size: 16px;
  cursor: pointer;
}

.more-options li a {
  text-decoration: none;
  color: black;
}

.more-options li:hover a {
  color: var(--secondary-color);
}

.more-options li i {
  margin-right: 10px;
}

.main-content {
  padding: 20px;
  margin-top: 20px; /* Add margin to prevent content from being hidden behind the sticky header */
}

.banner {
  background: linear-gradient(
    to right,
    var(--primary-color),
    var(--secondary-color)
  );
  color: var(--text-color);
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  margin: 5px 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.banner h2 {
  margin: 0;
  font-size: 22px;
  font-weight: bold;
}

.banner p {
  margin: 10px 0 0;
  font-size: 16px;
  color: white;
}

.market-tabs {
  display: flex;
  /* justify-content: space-around; */
  margin: 20px 0;
}

.market-tabs button {
  flex: 1 1;
  padding: 10px;
  border: none;
  background-color: var(--highlight-color);
  cursor: pointer;
  font-size: 16px;
  color: var(--text-color);
  border-radius: 5px;
  transition: background-color 0.3s, color 0.3s;
}

.market-tabs button:hover {
  background-color: var(--primary-color);
  color: var(--text-color);
}

.market-tabs .active {
  background-color: var(--primary-color);
  color: white;
}

.market-list {
  display: flex;
  flex-direction: column;
}

.market-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  background-color: var(--background-color);
  border-radius: 10px;
  margin-bottom: 8px;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
  text-decoration: none;
  color: inherit;
}

.market-item:hover {
  background-color: var(--highlight-color);
}

.market-info {
  display: flex;
  flex-direction: column;
  font-size: 14px;
}

.market-stats {
  text-align: right;
  font-size: 14px;
}

.negative {
  color: red;
}

.positive {
  color: green;
}
.modal1 {
  background-color: var(--background-color);
}

.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1000; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto; /* Enable scroll if needed */
  background-color: var(--background-color); /* Black w/ opacity */
}

.modal.show {
  display: flex; /* Display the modal */
  justify-content: center; /* Center the modal content */
  align-items: center; /* Center the modal content */
}

.modal-content {
  background-color: var(--background-color);
  margin: 5% auto; /* Adjusted for better alignment */
  padding: 20px;
  border: 1px solid #888;
  width: 90%; /* Could be more or less, depending on screen size */
  max-width: 500px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 50px;
}

.close {
  color: var(--text-color);
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

/* .form-group {
  margin: 10px 0;
} */

.form-group label {
  display: block;
  /* margin-bottom: 5px; */
  font-weight: bold;
  color: var(--text-color);
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: var(--background-color);
  color: var(--text-color);
}

.upload-screenshot {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding: 20px; */
  border: 2px dashed #ccc;
  border-radius: 10px;
  cursor: pointer;
  background-color: var(--background-color);
  color: var(--text-color);
}

.upload-icon {
  font-size: 36px;
  color: var(--secondary-color);
  margin-bottom: 10px;
}

.upload-screenshot img {
  max-width: 30%;
  height: auto;
  margin-top: 10px;
}

.submit-button {
  background: linear-gradient(to right, var(--secondary-color), #feb47b);
  color: white;
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  width: 100%;
  margin-top: 20px;
}

.container {
  width: 100%;
  max-width: 100%;
  background: var(--background-color);
  border-radius: 0px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow-y: auto;
  height: 100vh; /* Ensure the container takes the full height of the viewport */
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px; /* Add padding to make it look better */
  background: var(--background-color);
  color: var(--text-color);
  position: sticky; /* Make the header stick to the top */
  top: 0;
  z-index: 10;
  width: 95%; /* Make sure the header takes full width of the container */
  box-sizing: border-box; /* Include padding and border in the element's total width and height */
}

header .title-container {
  display: flex;
  align-items: center;
  /* background-color: var(--highlight-color); */
}

header h1 {
  margin: 0;
  font-size: 24px;
  display: flex;
  align-items: center;
}

.icons {
  display: flex;
  align-items: center;
}

.icon-notification {
  width: 24px;
  height: 24px;
  cursor: pointer;
  margin-left: 10px;
}

.menu-button {
  background: transparent;
  color: var(--text-color);
  border: none;
  font-size: 24px;
  cursor: pointer;
  margin-left: auto; /* Push the menu button to the far right */
}

.sidebar {
  position: fixed;
  left: -250px;
  top: 0;
  width: 210px;
  height: 100%;
  background-color: var(--highlight-color);
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  transition: left 0.3s;
  z-index: 1000;
  overflow-y: auto;
}

.sidebar.open {
  left: 0;
}

.sidebar-header {
  text-align: center;
  padding: 20px;
  background-color: var(--highlight-color);
  color: var(--text-color);
}

.sidebar-header h2 {
  margin: 0;
  font-size: 24px;
}

.sidebar-header p {
  margin: 0;
  font-size: 14px;
}

.credit {
  display: inline-block;
  background-color: #e0e0e0;
  color: #333;
  padding: 5px 10px;
  border-radius: 5px;
  margin-top: 10px;
}

.smart-contract-button {
  display: block;
  width: 80%;
  margin: 20px auto;
  background: linear-gradient(to right, var(--secondary-color), #feb47b);
  color: white;
  border: none;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.functions {
  margin-top: 30px;
  padding: 0 20px;
}

.functions h3 {
  margin: 0;
  font-size: 18px;
  color: var(--text-color);
}

.functions ul {
  list-style-type: none;
  padding: 0;
}

.functions li {
  padding: 10px 0;
  display: flex;
  align-items: center;
  font-size: 16px;
  cursor: pointer;
}

.functions li a {
  text-decoration: none;
  color: inherit;
}

.functions li:hover a {
  color: var(--secondary-color);
}

.functions li i {
  margin-right: 10px;
}

.more-options-button {
  display: block;
  width: 80%;
  margin: 20px auto;
  background: var(--secondary-color);
  color: var(--text-color);
  border: none;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.more-options.hidden {
  display: none;
}

.more-options ul {
  list-style-type: none;
  padding: 0;
}

.more-options li {
  padding: 10px 0;
  display: flex;
  align-items: center;
  font-size: 16px;
  cursor: pointer;
}

.more-options li a {
  text-decoration: none;
  color: var(--text-color);
}

.more-options li:hover a {
  color: var(--secondary-color);
}

.more-options li i {
  margin-right: 10px;
}

.main-content {
  padding: 10px;
  margin-top: 10px; /* Add margin to prevent content from being hidden behind the sticky header */
}

.banner {
  background: linear-gradient(
    to right,
    var(--primary-color),
    var(--secondary-color)
  );
  color: var(--text-color);
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  margin: 0 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.banner h2 {
  margin: 0;
  font-size: 22px;
  font-weight: bold;
  color: white;
}

.banner p {
  margin: 10px 0 0;
  font-size: 16px;
}

.market-tabs {
  display: flex;
  /* justify-content: space-around; */
  margin: 20px 0;
}

.market-tabs button {
  flex: 1 1;
  padding: 10px;
  border: none;
  background-color: var(--highlight-color);
  cursor: pointer;
  font-size: 16px;
  color: var(--text-color);
  border-radius: 5px;
  transition: background-color 0.3s, color 0.3s;
}

.market-tabs button:hover {
  background-color: var(--primary-color);
  color: var(--text-color);
}

.market-tabs .active {
  background-color: var(--primary-color);
  color: white;
}

.market-list {
  display: flex;
  flex-direction: column;
}

.market-item {
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  background-color: var(--background-color);
  /* border-radius: 10px; */
  margin-bottom: 8px;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
  text-decoration: none;
  color: inherit;
}

.market-item:hover {
  background-color: var(--highlight-color);
}

.market-info {
  display: flex;
  flex-direction: column;
  font-size: 14px;
}

.market-stats {
  text-align: right;
  font-size: 14px;
}

.negative {
  color: red;
}

.positive {
  color: green;
}

.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1000; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto; /* Enable scroll if needed */
  background-color: var(--background-color); /* Black w/ opacity */
}

.modal.show1 {
  display: flex; /* Display the modal */
  justify-content: center; /* Center the modal content */
  align-items: center; /* Center the modal content */
}
.modal-content1 {
  background-color: var(--background-color);
  /* Adjusted for better alignment */
  padding: 20px;
  border: 1px solid #888;
  width: 90%; /* Could be more or less, depending on screen size */
  max-width: 500px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.modal-content {
  background-color: var(--background-color);
  margin: 5% auto; /* Adjusted for better alignment */
  padding: 20px;
  border: 1px solid #888;
  width: 90%; /* Could be more or less, depending on screen size */
  max-width: 500px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.close {
  color: var(--text-color);
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

/* .form-group {
  margin: 10px 0;
} */

.form-group label {
  display: block;
  /* margin-bottom: 5px; */
  font-weight: bold;
  color: var(--text-color);
}

.form-group input {
  width: 100%;
  /* padding: 10px; */
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: var(--background-color);
  color: var(--text-color);
}

.upload-screenshot {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding: 20px; */
  border: 2px dashed #ccc;
  border-radius: 10px;
  cursor: pointer;
  background-color: var(--background-color);
  color: var(--text-color);
}

.upload-icon {
  font-size: 36px;
  color: var(--secondary-color);
  margin-bottom: 10px;
}

.upload-screenshot img {
  max-width: 30%;
  height: auto;
  margin-top: 10px;
}

.submit-button {
  background: linear-gradient(to right, var(--secondary-color), #feb47b);
  color: white;
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  width: 100%;
  margin-top: 20px;
}
.search-bar {
  /* margin: 10px; */
  text-align: center;
}

.search-bar input {
  padding: 10px;
  width: 300px;
  background-color: var(--highlight-color);
  /* border: 1px solid #ccc; */
  /* border-radius: 5px; */
  color: var(--text-color);
}
.main-balance-text {
  color: var(--text-color);
}
.labels23 {
  color: var(--text-color);
}
#icons-main-page {
  background-color: var(--highlight-color);
  color: var(--text-color);
}
.direction-button {
  width: 45%;
  padding: 5px 0;
  border: none;
  color: white;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  margin-right: 5px;
  border: 1px solid var(--text-color);
  background-color: var(--background-color); /* Default background */
}
.usdtIconss {
  background-color: var(--background-color);
}
.direction-button.green {
  background-color: green; /* Background for the "up" direction */
}
.direction-button.red {
  background-color: red; /* Background for the "up" direction */
}

.direction-button.black {
  background-color: var(
    --background-color
  ); /* Background for the "down" direction */
  color: var(--text-color);
}

.crypto-logo {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.footer-nav {
  border-top: 1px solid rgb(125, 124, 124);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: var(--background-color);
  color: white;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 5px 5px 5px 5px;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}

.footer-icons {
  list-style: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0;
  padding: 0;
}

.footer-icons li {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: var(--text-color);
  cursor: pointer;
}

.footer-icons li i {
  font-size: 20px;
  /* margin-bottom: 2px; */
}

.footer-icons li span {
  font-size: 12px;
}

.footer-icons li:hover {
  color: #ffd700; /* Highlight color on hover */
}

.main-content {
  padding-bottom: calc(90px + env(safe-area-inset-bottom));
}

/* Optional: a bit more breathing room between each coin row */
.market-item {
  margin-bottom: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/wallet/WalletDashboard.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;AACA;EACE,wCAAwC;EACxC,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAGhB,aAAa;EACb,SAAS,EAAE,qCAAqC;AAHlD;;AAMA;EACE,wCAAwC,EAAE,6BAA6B;EACvE,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB,EAAE,4BAA4B;EAChD,eAAe;EACf,eAAe,EAAE,qBAAqB;AACxC;;AAEA;EACE,yBAAyB,EAAE,sCAAsC;AACnE;;AAEA;EACE,wCAAwC;EACxC,wBAAwB;EACxB,YAAY;EACZ,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;;;;;GAKG;;AAEH;EACE,cAAc,EAAE,sBAAsB;AACxC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wCAAwC,EAAE,6BAA6B;AACzE;AACA;EACE,wBAAwB;EACxB,0CAA0C;EAC1C,UAAU;AACZ;AACA;EACE,kBAAkB,EAAE,gBAAgB;EACpC,0CAA0C,EAAE,sBAAsB;EAClE,qBAAqB,EAAE,oCAAoC;EAC3D,cAAc,EAAE,mCAAmC;EACnD,mBAAmB,EAAE,2CAA2C;AAClE;;AAEA;EACE,yBAAyB,EAAE,mCAAmC;EAC9D,YAAY;AACd;;AAEA;EACE;;;;GAIC;EACD,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,wCAAwC;EACxC,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,wBAAwB;AAC1B;AACA;;GAEG;AACH;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,wCAAwC;AAC1C;AACA;;EAEE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,kCAAkC;AACpC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,4EAA4E;EAC5E,wBAAwB;EACxB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa,EAAE,sBAAsB;EACrC,eAAe,EAAE,kBAAkB;EACnC,aAAa,EAAE,eAAe;EAC9B,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc,EAAE,4BAA4B;EAC5C,yCAAyC,EAAE,qBAAqB;AAClE;;AAEA;EACE,aAAa,EAAE,sBAAsB;EACrC,uBAAuB,EAAE,6BAA6B;EACtD,mBAAmB,EAAE,6BAA6B;AACpD;AACA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;AACA;;EAEE,YAAY;EACZ,qBAAqB;AACvB;AACA;;GAEG;;AAEH;EACE,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sEAAsE;EACtE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;;GAEG;AACH;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,eAAe;EACf,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa,EAAE,+DAA+D;AAChF;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB,EAAE,uCAAuC;EAC3D,mCAAmC;EACnC,wBAAwB;EACxB,gBAAgB,EAAE,qCAAqC;EACvD,MAAM;EACN,WAAW;EACX,UAAU,EAAE,2DAA2D;EACvE,sBAAsB,EAAE,uEAAuE;AACjG;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa,EAAE,sBAAsB;EACrC,uBAAuB,EAAE,0CAA0C;EACnE,mBAAmB,EAAE,wCAAwC;AAC/D;AACA;EACE,yCAAyC;EACzC,8CAA8C;EAC9C,8CAA8C;EAC9C,eAAe,EAAE,kCAAkC;EACnD,aAAa;EACb,sBAAsB;EACtB,UAAU,EAAE,oDAAoD;EAChE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;AACA;EACE,yCAAyC;EACzC,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB,EAAE,0CAA0C;AAC/D;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,wCAAwC;EACxC,wCAAwC;EACxC,qBAAqB;EACrB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,sEAAsE;EACtE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB,EAAE,6EAA6E;AACjG;;AAEA;EACE;;;;GAIC;EACD,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,wCAAwC;EACxC,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;AACA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa,EAAE,sBAAsB;EACrC,eAAe,EAAE,kBAAkB;EACnC,aAAa,EAAE,eAAe;EAC9B,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc,EAAE,4BAA4B;EAC5C,yCAAyC,EAAE,qBAAqB;AAClE;;AAEA;EACE,aAAa,EAAE,sBAAsB;EACrC,uBAAuB,EAAE,6BAA6B;EACtD,mBAAmB,EAAE,6BAA6B;AACpD;;AAEA;EACE,yCAAyC;EACzC,eAAe,EAAE,kCAAkC;EACnD,aAAa;EACb,sBAAsB;EACtB,UAAU,EAAE,oDAAoD;EAChE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sEAAsE;EACtE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa,EAAE,+DAA+D;AAChF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB,EAAE,uCAAuC;EAC3D,mCAAmC;EACnC,wBAAwB;EACxB,gBAAgB,EAAE,qCAAqC;EACvD,MAAM;EACN,WAAW;EACX,UAAU,EAAE,2DAA2D;EACvE,sBAAsB,EAAE,uEAAuE;AACjG;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB,EAAE,0CAA0C;AAC/D;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,wCAAwC;EACxC,wCAAwC;EACxC,qBAAqB;EACrB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,sEAAsE;EACtE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,kCAAkC;EAClC,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB,EAAE,6EAA6E;AACjG;;AAEA;EACE;;;;GAIC;EACD,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,wCAAwC;EACxC,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa,EAAE,sBAAsB;EACrC,eAAe,EAAE,kBAAkB;EACnC,aAAa,EAAE,eAAe;EAC9B,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc,EAAE,4BAA4B;EAC5C,yCAAyC,EAAE,qBAAqB;AAClE;;AAEA;EACE,aAAa,EAAE,sBAAsB;EACrC,uBAAuB,EAAE,6BAA6B;EACtD,mBAAmB,EAAE,6BAA6B;AACpD;AACA;EACE,yCAAyC;EACzC,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,UAAU,EAAE,oDAAoD;EAChE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,yCAAyC;EACzC,eAAe,EAAE,kCAAkC;EACnD,aAAa;EACb,sBAAsB;EACtB,UAAU,EAAE,oDAAoD;EAChE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sEAAsE;EACtE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,wCAAwC;EACxC,4BAA4B;EAC5B,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wCAAwC;EACxC,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mCAAmC;EACnC,yCAAyC,EAAE,uBAAuB;AACpE;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,uBAAuB,EAAE,sCAAsC;AACjE;AACA;EACE,qBAAqB,EAAE,sCAAsC;AAC/D;;AAEA;EACE;;GAEC,EAAE,wCAAwC;EAC3C,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,wCAAwC;EACxC,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,yCAAyC;EACzC,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,wBAAwB;EACxB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc,EAAE,6BAA6B;AAC/C;;AAEA;EACE,wDAAwD;AAC1D;;AAEA,8DAA8D;AAC9D;EACE,mBAAmB;AACrB","sourcesContent":[":root {\n  --background-color: #fff;\n  --text-color: #000;\n  --primary-color: #fff;\n  --secondary-color: #fff;\n  --highlight-color: #f4f4f6;\n  --modal-background: #fefefe;\n}\n\n[data-theme=\"dark\"] {\n  --background-color: #000000;\n  --text-color: #f0f0f0;\n  --primary-color: #111b21;\n  --secondary-color: #000000;\n  --highlight-color: #222e35;\n  --modal-background: #111b21;\n}\n#select1 {\n  color: var(--text-color);\n  background-color: var(--background-color);\n}\n.select11 {\n  background-color: var(--secondary-color);\n  color: var(--text-color);\n}\n.text1 {\n  color: var(--text-color);\n}\n.header-text {\n  color: var(--text-color);\n}\n#modalBack {\n  background-color: var(--highlight-color);\n}\nbody {\n  background-color: var(--background-color);\n  color: var(--text-color);\n}\n.theme-switch {\n  position: relative;\n  display: inline-block;\n  width: 30px;\n  height: 15px;\n}\n\n.theme-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.4s;\n  border-radius: 34px;\n}\n.transaction-summary {\n  background-color: var(--highlight-color);\n}\n.optionss {\n  background-color: var(--background-color);\n  color: var(--text-color);\n}\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 12px;\n  width: 12px;\n  left: 0px;\n  bottom: 1px;\n  background-color: white;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n\ninput:checked + .slider {\n  background-color: #4caf50;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(17px);\n}\n\nheader {\n  background-color: var(--background-color);\n  color: var(--text-color);\n  padding: 20px;\n  border-radius: 10px;\n  margin-top: 5px;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.wallet-header {\n  background: var(--highlight-color);\n  color: var(--text-color);\n}\n\n.wallet-tabs .active {\n  background: var(--primary-color);\n  color: var(--text-color);\n}\nh1 {\n  color: white;\n}\n.button-group {\n  margin-top: 30px;\n}\n.button-group {\n  display: flex;\n  gap: 10px; /* Optional spacing between buttons */\n}\n\n.tab-button {\n  background-color: var(--highlight-color); /* Default background color */\n  color: var(--text-color);\n  border: 1px solid white;\n  border-radius: 5px;\n  padding: 10px 20px; /* Adjust padding for size */\n  cursor: pointer;\n  font-size: 14px; /* Adjust font size */\n}\n\n.tab-button.active {\n  background-color: #7d9aea; /* Background color for active state */\n}\n\n.button-group .tab-button {\n  background-color: var(--highlight-color);\n  color: var(--text-color);\n  padding: 5px;\n  width: 150px;\n}\n.yaxis-graph {\n  color: var(--text-color);\n}\n/* .footer-icons li {\n  padding: 3px;\n  cursor: pointer;\n  border-radius: 5px;\n  margin: 0 3px;\n} */\n\n.footer-icons li.active {\n  color: #7d9aea; /* Active text color */\n}\n.modal-content5 {\n  background-color: var(--highlight-color);\n}\n.button-group .tab-button.active {\n  background-color: #7d9aea;\n  color: black;\n  padding: 5px;\n}\n.period-button {\n  padding: 5px 10px;\n  color: var(--text-color);\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  background-color: var(--highlight-color); /* Default background color */\n}\n.cntact-usss {\n  color: var(--text-color);\n  border-bottom: 1px solid var(--text-color);\n  width: 30%;\n}\n.contect-us-header {\n  text-align: center; /* Center text */\n  border-bottom: 1px solid var(--text-color); /* Border under text */\n  display: inline-block; /* Makes the width fit the content */\n  margin: 0 auto; /* Centers the block horizontally */\n  padding-bottom: 5px; /* Adds space between the text and border */\n}\n\n.period-button.selected {\n  background-color: #7d9aea; /* Background color when selected */\n  color: white;\n}\n\n.banner {\n  background: linear-gradient(\n    to right,\n    var(--primary-color),\n    var(--secondary-color)\n  );\n  color: var(--text-color);\n}\n\n.market-item {\n  background-color: var(--background-color);\n  color: var(--text-color);\n}\n\n.market-item:hover {\n  background-color: var(--highlight-color);\n}\n\n.copied-message {\n  position: fixed;\n  top: 10px;\n  right: 10px;\n  background-color: var(--highlight-color);\n  color: var(--text-color);\n  padding: 10px;\n  border-radius: 5px;\n  z-index: 1000;\n}\n\n.wallet {\n  width: 100%;\n  max-width: 500px;\n  background: var(--highlight-color);\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  text-align: center;\n  margin: 17px auto;\n}\n\n.wallet-header {\n  background: var(--highlight-color);\n  padding: 10px;\n  color: var(--text-color);\n}\n/* #recharge-modal {\n  background-color: var(--background-color);\n} */\n.wallet-header h1 {\n  margin: 0;\n  font-size: 24px;\n}\n\n.wallet-balance {\n  padding: 10px;\n  color: var(--text-color);\n}\n\n.wallet-balance p {\n  margin: 5px 0;\n  font-size: 16px;\n}\n#recharggge {\n  background-color: var(--highlight-color);\n}\nb,\nstrong {\n  font-weight: bolder;\n  color: white;\n}\n.wallet-tabs {\n  padding: 5px;\n  display: flex;\n  justify-content: space-around;\n  background: var(--highlight-color);\n}\n.tabsss {\n  border: \"1px solid white\";\n}\n\n.wallet-tabs button {\n  flex: 1;\n  padding: 5px;\n  border: none;\n  background: transparent;\n  font-size: 16px;\n  cursor: pointer;\n  outline: none;\n}\n\n.wallet-tabs .active {\n  background: #7d9aea;\n  color: white;\n  border-radius: 5px;\n}\n\n.wallet-content {\n  padding: 20px;\n}\n\n.tab-content {\n  display: none;\n}\n\n.tab-content.active {\n  display: block;\n}\n\n.wallet-qr img {\n  width: 150px;\n}\n\n.wallet-qr p {\n  font-size: 12px;\n  color: var(--text-color);\n}\n\n.copy-address {\n  color: var(--secondary-color);\n  text-decoration: blink;\n  cursor: pointer;\n}\n\n.recharge-link {\n  color: var(--secondary-color);\n  text-decoration: blink;\n  cursor: pointer;\n}\n\n.currency-tag {\n  background: #ff9800;\n  color: white;\n  padding: 5px 10px;\n  border-radius: 20px;\n  font-size: 14px;\n  display: inline-block;\n  margin-right: 10px;\n}\n\n.input-field {\n  width: calc(100% - 40px);\n  padding: 10px;\n  margin: 10px 0;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background-color: var(--background-color);\n  color: var(--text-color);\n}\n\n.input-field.small-input {\n  width: calc(50% - 40px);\n}\n\n.send-button,\n.convert-button {\n  /* background: linear-gradient(to right, var(--secondary-color), #feb47b); */\n  color: var(--text-color);\n  padding: 10px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n  width: calc(100% - 40px);\n  margin: 10px 20px;\n}\n\n.max-button {\n  color: var(--secondary-color);\n  cursor: pointer;\n  margin-left: 10px;\n}\n\n.modal {\n  display: none; /* Hidden by default */\n  position: fixed; /* Stay in place */\n  z-index: 1000; /* Sit on top */\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto; /* Enable scroll if needed */\n  background-color: var(--background-color); /* Black w/ opacity */\n}\n\n.modal.show {\n  display: flex; /* Display the modal */\n  justify-content: center; /* Center the modal content */\n  align-items: center; /* Center the modal content */\n}\n.modal-content1 {\n  background-color: var(--background-color);\n}\n\n.modal-content {\n  background-color: var(--background-color);\n  padding: 20px;\n  border: 1px solid #888;\n  width: 90%;\n  max-width: 500px;\n  border-radius: 10px;\n  /* height: 400px; */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin-top: 60px;\n}\n\n.close {\n  color: var(--text-color);\n  font-size: 28px;\n  font-weight: bold;\n  position: absolute;\n  top: 10px;\n  right: 20px;\n  cursor: pointer;\n}\n.close:hover,\n.close:focus {\n  color: black;\n  text-decoration: none;\n}\n/* .form-group {\n  margin: 5px 0;\n} */\n\n.form-group label {\n  display: block;\n  /* margin-bottom: 5px; */\n  font-weight: bold;\n  color: var(--text-color);\n}\n\n.form-group input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background-color: var(--background-color);\n  color: var(--text-color);\n}\n\n.upload-screenshot {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* padding: 20px; */\n  border: 2px dashed #ccc;\n  border-radius: 10px;\n  cursor: pointer;\n  background-color: var(--background-color);\n  color: var(--text-color);\n}\n\n.upload-icon {\n  font-size: 36px;\n  color: var(--secondary-color);\n  margin-bottom: 10px;\n}\n\n.upload-screenshot img {\n  max-width: 30%;\n  height: auto;\n  margin-top: 10px;\n}\n\n.submit-button {\n  background: linear-gradient(to right, var(--secondary-color), #feb47b);\n  color: white;\n  padding: 10px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n  width: 100%;\n  margin-top: 20px;\n}\n/* .featured-crypto-list {\n  background-color: var(--highlight-color);\n} */\n#predict-chart {\n  background-color: var(--background-color);\n  color: var(--text-color);\n}\n.prediction-summary {\n  background-color: var(--background-color);\n}\n.container {\n  width: 100%;\n  max-width: 100%;\n  background: var(--background-color);\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  position: relative;\n  overflow-y: auto;\n  height: 100vh; /* Ensure the container takes the full height of the viewport */\n}\n.featured-crypto-item {\n  background-color: var(--background-color);\n}\nheader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 10px; /* Add padding to make it look better */\n  background: var(--background-color);\n  color: var(--text-color);\n  position: sticky; /* Make the header stick to the top */\n  top: 0;\n  z-index: 10;\n  width: 95%; /* Make sure the header takes full width of the container */\n  box-sizing: border-box; /* Include padding and border in the element's total width and height */\n}\n#entrustModal {\n  background-color: var(--background-color);\n}\nheader .title-container {\n  display: flex;\n  align-items: center;\n  /* background: var(--highlight-color); */\n}\n.back-button {\n  color: var(--text-color);\n}\n#crypto-modal {\n  background-color: var(--background-color);\n}\n#copy-texts {\n  color: var(--text-color);\n}\n.modal.show {\n  display: flex; /* Display the modal */\n  justify-content: center; /* Center the modal content horizontally */\n  align-items: center; /* Center the modal content vertically */\n}\n#wallet-modalss {\n  background-color: var(--background-color);\n  /* background-color: var(--highlight-color); */\n  /* background-color: var(--highlight-color); */\n  margin: 5% auto; /* Adjusted for better alignment */\n  padding: 20px;\n  border: 1px solid #888;\n  width: 90%; /* Could be more or less, depending on screen size */\n  max-width: 500px;\n  border-radius: 10px;\n  margin-top: 50px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n.modal-content {\n  background-color: var(--background-color);\n  margin: 5% auto;\n  padding: 20px;\n  border: 1px solid #888;\n  width: 90%;\n  max-width: 500px;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin-top: 50px;\n}\n\n.close {\n  color: var(--text-color);\n  float: right;\n  font-size: 28px;\n  font-weight: bold;\n}\n\n.close:hover,\n.close:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer;\n}\n\nheader h1 {\n  margin: 0;\n  font-size: 24px;\n  display: flex;\n  align-items: center;\n}\n\n.icons {\n  display: flex;\n  align-items: center;\n}\n\n.icon-notification {\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  margin-left: 10px;\n}\n\n.menu-button {\n  background: transparent;\n  color: var(--text-color);\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  margin-left: auto; /* Push the menu button to the far right */\n}\n\n.sidebar {\n  position: fixed;\n  left: -250px;\n  top: 0;\n  width: 210px;\n  height: 100%;\n  background-color: var(--highlight-color);\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);\n  transition: left 0.3s;\n  z-index: 1000;\n  overflow-y: auto;\n}\n\n.sidebar.open {\n  left: 0;\n}\n\n.sidebar-header {\n  text-align: center;\n  padding: 20px;\n  background-color: var(--highlight-color);\n  color: var(--text-color);\n  border-bottom: 0.5px solid rgb(197, 194, 194);\n}\n\n.sidebar-header h2 {\n  margin: 0;\n  font-size: 24px;\n}\n\n.sidebar-header p {\n  margin: 0;\n  font-size: 14px;\n  color: var(--text-color);\n}\n\n.credit {\n  display: inline-block;\n  background-color: #e0e0e0;\n  color: #333;\n  padding: 5px 10px;\n  border-radius: 5px;\n  margin-top: 10px;\n}\n\n.smart-contract-button {\n  display: block;\n  width: 80%;\n  margin: 20px auto;\n  background: linear-gradient(to right, var(--secondary-color), #feb47b);\n  color: white;\n  border: none;\n  padding: 10px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.functions {\n  margin-top: 30px;\n  padding: 0 20px;\n}\n\n.functions h3 {\n  margin: 0;\n  font-size: 18px;\n  color: var(--text-color);\n}\n\n.functions ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.functions li {\n  padding: 10px 0;\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.functions li a {\n  text-decoration: none;\n  color: inherit;\n}\n\n.functions li:hover a {\n  color: var(--secondary-color);\n}\n\n.functions li i {\n  margin-right: 10px;\n}\n\n.more-options-button {\n  display: block;\n  width: 80%;\n  margin: 20px auto;\n  color: black;\n  border: none;\n  padding: 10px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.more-options.hidden {\n  display: none;\n}\n\n.more-options ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.more-options li {\n  padding: 10px 0;\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.more-options li a {\n  text-decoration: none;\n  color: black;\n}\n\n.more-options li:hover a {\n  color: var(--secondary-color);\n}\n\n.more-options li i {\n  margin-right: 10px;\n}\n\n.main-content {\n  padding: 20px;\n  margin-top: 20px; /* Add margin to prevent content from being hidden behind the sticky header */\n}\n\n.banner {\n  background: linear-gradient(\n    to right,\n    var(--primary-color),\n    var(--secondary-color)\n  );\n  color: var(--text-color);\n  padding: 20px;\n  border-radius: 10px;\n  text-align: center;\n  margin: 5px 0;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.banner h2 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: bold;\n}\n\n.banner p {\n  margin: 10px 0 0;\n  font-size: 16px;\n  color: white;\n}\n\n.market-tabs {\n  display: flex;\n  /* justify-content: space-around; */\n  margin: 20px 0;\n}\n\n.market-tabs button {\n  flex: 1;\n  padding: 10px;\n  border: none;\n  background-color: var(--highlight-color);\n  cursor: pointer;\n  font-size: 16px;\n  color: var(--text-color);\n  border-radius: 5px;\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.market-tabs button:hover {\n  background-color: var(--primary-color);\n  color: var(--text-color);\n}\n\n.market-tabs .active {\n  background-color: var(--primary-color);\n  color: white;\n}\n\n.market-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.market-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px;\n  background-color: var(--background-color);\n  border-radius: 10px;\n  margin-bottom: 8px;\n  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */\n  text-decoration: none;\n  color: inherit;\n}\n\n.market-item:hover {\n  background-color: var(--highlight-color);\n}\n\n.market-info {\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n}\n\n.market-stats {\n  text-align: right;\n  font-size: 14px;\n}\n\n.negative {\n  color: red;\n}\n\n.positive {\n  color: green;\n}\n.modal1 {\n  background-color: var(--background-color);\n}\n\n.modal {\n  display: none; /* Hidden by default */\n  position: fixed; /* Stay in place */\n  z-index: 1000; /* Sit on top */\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto; /* Enable scroll if needed */\n  background-color: var(--background-color); /* Black w/ opacity */\n}\n\n.modal.show {\n  display: flex; /* Display the modal */\n  justify-content: center; /* Center the modal content */\n  align-items: center; /* Center the modal content */\n}\n\n.modal-content {\n  background-color: var(--background-color);\n  margin: 5% auto; /* Adjusted for better alignment */\n  padding: 20px;\n  border: 1px solid #888;\n  width: 90%; /* Could be more or less, depending on screen size */\n  max-width: 500px;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin-top: 50px;\n}\n\n.close {\n  color: var(--text-color);\n  float: right;\n  font-size: 28px;\n  font-weight: bold;\n}\n\n.close:hover,\n.close:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n/* .form-group {\n  margin: 10px 0;\n} */\n\n.form-group label {\n  display: block;\n  /* margin-bottom: 5px; */\n  font-weight: bold;\n  color: var(--text-color);\n}\n\n.form-group input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background-color: var(--background-color);\n  color: var(--text-color);\n}\n\n.upload-screenshot {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* padding: 20px; */\n  border: 2px dashed #ccc;\n  border-radius: 10px;\n  cursor: pointer;\n  background-color: var(--background-color);\n  color: var(--text-color);\n}\n\n.upload-icon {\n  font-size: 36px;\n  color: var(--secondary-color);\n  margin-bottom: 10px;\n}\n\n.upload-screenshot img {\n  max-width: 30%;\n  height: auto;\n  margin-top: 10px;\n}\n\n.submit-button {\n  background: linear-gradient(to right, var(--secondary-color), #feb47b);\n  color: white;\n  padding: 10px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n  width: 100%;\n  margin-top: 20px;\n}\n\n.container {\n  width: 100%;\n  max-width: 100%;\n  background: var(--background-color);\n  border-radius: 0px;\n  overflow: hidden;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  position: relative;\n  overflow-y: auto;\n  height: 100vh; /* Ensure the container takes the full height of the viewport */\n}\n\nheader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 10px; /* Add padding to make it look better */\n  background: var(--background-color);\n  color: var(--text-color);\n  position: sticky; /* Make the header stick to the top */\n  top: 0;\n  z-index: 10;\n  width: 95%; /* Make sure the header takes full width of the container */\n  box-sizing: border-box; /* Include padding and border in the element's total width and height */\n}\n\nheader .title-container {\n  display: flex;\n  align-items: center;\n  /* background-color: var(--highlight-color); */\n}\n\nheader h1 {\n  margin: 0;\n  font-size: 24px;\n  display: flex;\n  align-items: center;\n}\n\n.icons {\n  display: flex;\n  align-items: center;\n}\n\n.icon-notification {\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  margin-left: 10px;\n}\n\n.menu-button {\n  background: transparent;\n  color: var(--text-color);\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  margin-left: auto; /* Push the menu button to the far right */\n}\n\n.sidebar {\n  position: fixed;\n  left: -250px;\n  top: 0;\n  width: 210px;\n  height: 100%;\n  background-color: var(--highlight-color);\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);\n  transition: left 0.3s;\n  z-index: 1000;\n  overflow-y: auto;\n}\n\n.sidebar.open {\n  left: 0;\n}\n\n.sidebar-header {\n  text-align: center;\n  padding: 20px;\n  background-color: var(--highlight-color);\n  color: var(--text-color);\n}\n\n.sidebar-header h2 {\n  margin: 0;\n  font-size: 24px;\n}\n\n.sidebar-header p {\n  margin: 0;\n  font-size: 14px;\n}\n\n.credit {\n  display: inline-block;\n  background-color: #e0e0e0;\n  color: #333;\n  padding: 5px 10px;\n  border-radius: 5px;\n  margin-top: 10px;\n}\n\n.smart-contract-button {\n  display: block;\n  width: 80%;\n  margin: 20px auto;\n  background: linear-gradient(to right, var(--secondary-color), #feb47b);\n  color: white;\n  border: none;\n  padding: 10px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.functions {\n  margin-top: 30px;\n  padding: 0 20px;\n}\n\n.functions h3 {\n  margin: 0;\n  font-size: 18px;\n  color: var(--text-color);\n}\n\n.functions ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.functions li {\n  padding: 10px 0;\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.functions li a {\n  text-decoration: none;\n  color: inherit;\n}\n\n.functions li:hover a {\n  color: var(--secondary-color);\n}\n\n.functions li i {\n  margin-right: 10px;\n}\n\n.more-options-button {\n  display: block;\n  width: 80%;\n  margin: 20px auto;\n  background: var(--secondary-color);\n  color: var(--text-color);\n  border: none;\n  padding: 10px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.more-options.hidden {\n  display: none;\n}\n\n.more-options ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.more-options li {\n  padding: 10px 0;\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.more-options li a {\n  text-decoration: none;\n  color: var(--text-color);\n}\n\n.more-options li:hover a {\n  color: var(--secondary-color);\n}\n\n.more-options li i {\n  margin-right: 10px;\n}\n\n.main-content {\n  padding: 10px;\n  margin-top: 10px; /* Add margin to prevent content from being hidden behind the sticky header */\n}\n\n.banner {\n  background: linear-gradient(\n    to right,\n    var(--primary-color),\n    var(--secondary-color)\n  );\n  color: var(--text-color);\n  padding: 20px;\n  border-radius: 10px;\n  text-align: center;\n  margin: 0 0;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.banner h2 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: bold;\n  color: white;\n}\n\n.banner p {\n  margin: 10px 0 0;\n  font-size: 16px;\n}\n\n.market-tabs {\n  display: flex;\n  /* justify-content: space-around; */\n  margin: 20px 0;\n}\n\n.market-tabs button {\n  flex: 1;\n  padding: 10px;\n  border: none;\n  background-color: var(--highlight-color);\n  cursor: pointer;\n  font-size: 16px;\n  color: var(--text-color);\n  border-radius: 5px;\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.market-tabs button:hover {\n  background-color: var(--primary-color);\n  color: var(--text-color);\n}\n\n.market-tabs .active {\n  background-color: var(--primary-color);\n  color: white;\n}\n\n.market-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.market-item {\n  border: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px;\n  background-color: var(--background-color);\n  /* border-radius: 10px; */\n  margin-bottom: 8px;\n  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */\n  text-decoration: none;\n  color: inherit;\n}\n\n.market-item:hover {\n  background-color: var(--highlight-color);\n}\n\n.market-info {\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n}\n\n.market-stats {\n  text-align: right;\n  font-size: 14px;\n}\n\n.negative {\n  color: red;\n}\n\n.positive {\n  color: green;\n}\n\n.modal {\n  display: none; /* Hidden by default */\n  position: fixed; /* Stay in place */\n  z-index: 1000; /* Sit on top */\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto; /* Enable scroll if needed */\n  background-color: var(--background-color); /* Black w/ opacity */\n}\n\n.modal.show1 {\n  display: flex; /* Display the modal */\n  justify-content: center; /* Center the modal content */\n  align-items: center; /* Center the modal content */\n}\n.modal-content1 {\n  background-color: var(--background-color);\n  /* Adjusted for better alignment */\n  padding: 20px;\n  border: 1px solid #888;\n  width: 90%; /* Could be more or less, depending on screen size */\n  max-width: 500px;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n.modal-content {\n  background-color: var(--background-color);\n  margin: 5% auto; /* Adjusted for better alignment */\n  padding: 20px;\n  border: 1px solid #888;\n  width: 90%; /* Could be more or less, depending on screen size */\n  max-width: 500px;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.close {\n  color: var(--text-color);\n  float: right;\n  font-size: 28px;\n  font-weight: bold;\n}\n\n.close:hover,\n.close:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n/* .form-group {\n  margin: 10px 0;\n} */\n\n.form-group label {\n  display: block;\n  /* margin-bottom: 5px; */\n  font-weight: bold;\n  color: var(--text-color);\n}\n\n.form-group input {\n  width: 100%;\n  /* padding: 10px; */\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background-color: var(--background-color);\n  color: var(--text-color);\n}\n\n.upload-screenshot {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* padding: 20px; */\n  border: 2px dashed #ccc;\n  border-radius: 10px;\n  cursor: pointer;\n  background-color: var(--background-color);\n  color: var(--text-color);\n}\n\n.upload-icon {\n  font-size: 36px;\n  color: var(--secondary-color);\n  margin-bottom: 10px;\n}\n\n.upload-screenshot img {\n  max-width: 30%;\n  height: auto;\n  margin-top: 10px;\n}\n\n.submit-button {\n  background: linear-gradient(to right, var(--secondary-color), #feb47b);\n  color: white;\n  padding: 10px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n  width: 100%;\n  margin-top: 20px;\n}\n.search-bar {\n  /* margin: 10px; */\n  text-align: center;\n}\n\n.search-bar input {\n  padding: 10px;\n  width: 300px;\n  background-color: var(--highlight-color);\n  /* border: 1px solid #ccc; */\n  /* border-radius: 5px; */\n  color: var(--text-color);\n}\n.main-balance-text {\n  color: var(--text-color);\n}\n.labels23 {\n  color: var(--text-color);\n}\n#icons-main-page {\n  background-color: var(--highlight-color);\n  color: var(--text-color);\n}\n.direction-button {\n  width: 45%;\n  padding: 5px 0;\n  border: none;\n  color: white;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n  margin-right: 5px;\n  border: 1px solid var(--text-color);\n  background-color: var(--background-color); /* Default background */\n}\n.usdtIconss {\n  background-color: var(--background-color);\n}\n.direction-button.green {\n  background-color: green; /* Background for the \"up\" direction */\n}\n.direction-button.red {\n  background-color: red; /* Background for the \"up\" direction */\n}\n\n.direction-button.black {\n  background-color: var(\n    --background-color\n  ); /* Background for the \"down\" direction */\n  color: var(--text-color);\n}\n\n.crypto-logo {\n  width: 40px;\n  height: 40px;\n  margin-right: 10px;\n}\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.footer-nav {\n  border-top: 1px solid rgb(125, 124, 124);\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: var(--background-color);\n  color: white;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  padding: 5px 5px 5px 5px;\n  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.2);\n  z-index: 1000;\n}\n\n.footer-icons {\n  list-style: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.footer-icons li {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  color: var(--text-color);\n  cursor: pointer;\n}\n\n.footer-icons li i {\n  font-size: 20px;\n  /* margin-bottom: 2px; */\n}\n\n.footer-icons li span {\n  font-size: 12px;\n}\n\n.footer-icons li:hover {\n  color: #ffd700; /* Highlight color on hover */\n}\n\n.main-content {\n  padding-bottom: calc(90px + env(safe-area-inset-bottom));\n}\n\n/* Optional: a bit more breathing room between each coin row */\n.market-item {\n  margin-bottom: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
